/*
	Adapted from https://gist.github.com/matthewsuan/2bdc9e7f459d5b073d58d1ebc0613169
*/

import axios from "axios";
import { v4 as uuidv4 } from "uuid";

const MAX_REQUESTS_COUNT = 5;
const INTERVAL_MS = 10;
let PENDING_REQUESTS = 0;

// create new axios instance
const api = axios.create( {} );

const clientId = uuidv4();
api.defaults.headers.common[ "x-teaming-client-id" ] = clientId;
api.defaults.headers.common[ "x-teaming-client" ] = "teaming-ui";

/**
 * Axios Request Interceptor
 */
api.interceptors.request.use( function ( config ) {
	return new Promise( resolve => {
		const interval = setInterval( () => {
			if ( PENDING_REQUESTS < MAX_REQUESTS_COUNT ) {
				PENDING_REQUESTS++;
				clearInterval( interval );
				resolve( config );
			}
		}, INTERVAL_MS );
	} );
} );

/**
 * Axios Response Interceptor
 */
api.interceptors.response.use( function ( response ) {
	PENDING_REQUESTS = Math.max( 0, PENDING_REQUESTS - 1 );
	return Promise.resolve( response );
}, function ( error ) {
	PENDING_REQUESTS = Math.max( 0, PENDING_REQUESTS - 1 );
	return Promise.reject( error );
} );

export { api as axios };
export { clientId as clientIdentifier };
